import React, { useContext } from 'react'
import { SessionContextStore } from '../../../context/SessionContext'
import { PAYMENT_FEE } from '../../../Constants'
import { getPlanTotalPrice } from './utils'

export default plan => {
  const { user } = useContext(SessionContextStore)
  if (user.userVehicles.length > 0)
    return (
      <div className={`plan-card ${plan.selected ? 'selected' : ''} ${plan.disabled ? 'disabled' : ''}`} onClick={plan.setSelected}>
        <div className={`title ${plan.selected ? 'selected' : ''}`}>{plan.label}</div>

        <div className="body">
          <div style={{ borderBottom: '1px solid #e5dfd8' }}>
            <span className="currency">$</span>
            <span className="price">{Math.ceil(getPlanTotalPrice(plan, user.userVehicles) + PAYMENT_FEE).toLocaleString()}</span>
          </div>
          <div className={`estimation  ${plan.selected ? 'selected' : ''}`}>{plan.period === 'month' ? 'Monthly estimation' : ''}</div>
        </div>
      </div>
    )
  else return <div></div>
}
